import gql from "@/api/gql"

const products = gql`
	query products($where: productWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		products: products_2(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			totalCount
			list {
				name
				productId {
					type
					version
					plan
				}
				insurer {
					id
				}
			}
		}
	}
`

const product = gql`
	query products($where: productWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		products: products_2(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			totalCount
			list {
				name
				productId {
					type
					version
					plan
				}
				insurer {
					id
					name
				}
				createdBy {
					username
				}
				createdAt
				lastModifiedAt
				lastModifiedBy {
					username
				}
			}
		}
	}
`

const createProduct = gql`
	mutation createProduct($product: createProductInput!) {
		createProduct(product: $product) {
			createdBy {
				username
			}
			productId {
				plan
				type
				version
			}
		}
	}
`

const updateProduct = gql`
	mutation updateProduct($productId: productIdInput!, $input: updateProductInput) {
		updateProduct(productId: $productId, input: $input) {
			productId {
				plan
				type
				version
			}
		}
	}
`

const upsertL10n = gql`
	mutation upsertL10n($l10n: upsertL10nInput) {
		upsertL10n(l10n: $l10n) {
			errors
			status
		}
	}
`

const deleteProduct = gql`
	mutation deleteProduct($productId: productIdInput!) {
		deleteProduct(productId: $productId) {
			status
			errors
		}
	}
`

const benefitGraph = gql`
	fragment benefit on benefitGraph {
		typeId
		rawData
		value
		detailedValue
		parentOptionKeys
		name
		description
		currencyCode
		optionKey
		isValueInput
	}

	query products($where: productWhereInput) {
		products: products_2(where: $where) {
			totalCount
			list {
				name
				benefitGraph {
					...benefit
					options {
						...benefit
					}
					children {
						...benefit
						options {
							...benefit
						}
						children {
							...benefit
							options {
								...benefit
							}
							children {
								...benefit
								options {
									...benefit
								}
								children {
									...benefit
									options {
										...benefit
									}
									children {
										...benefit
										options {
											...benefit
										}
										children {
											...benefit
											options {
												...benefit
											}
										}
									}
								}
							}
						}
					}
				}
				productId {
					type
					version
					plan
				}
			}
		}
	}
`

const addBenefit = gql`
	mutation addBenefit($productId: productIdInput!, $input: benefitInput!) {
		addBenefit(productId: $productId, input: $input) {
			status
			errors
		}
	}
`

const updateBenefit = gql`
	mutation updateBenefit($productId: productIdInput!, $typeId: String!, $optionKey: String, $input: updateBenefitInput!) {
		updateBenefit(productId: $productId, typeId: $typeId, optionKey: $optionKey, input: $input) {
			status
			errors
		}
	}
`

const removeBenefit = gql`
	mutation removeBenefit($productId: productIdInput!, $typeId: String!, $optionKey: String) {
		removeBenefit(productId: $productId, typeId: $typeId, optionKey: $optionKey) {
			status
			errors
		}
	}
`

const pricingLogic = gql`
	query pricingLogic($where: productWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		products: products_2(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			totalCount
			list {
				pricing {
					amountLogic
				}
			}
		}
	}
`

const createPriceLogic = gql`
	mutation createPriceLogic($productId: productIdInput!, $input: priceLogicInput!) {
		createPriceLogic(productId: $productId, input: $input) {
			errors
			status
		}
	}
`

const updatePriceLogic = gql`
	mutation updatePriceLogic($productId: productIdInput!, $input: priceLogicInput!) {
		updatePriceLogic(productId: $productId, input: $input) {
			errors
			status
		}
	}
`

const underwritingLogic = gql`
	query underwritingLogic($where: productWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		products: products_2(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			totalCount
			list {
				underwritingRulesJson
			}
		}
	}
`

const updateUnderwritingLogic = gql`
	mutation updateUnderwritingLogic($productId: productIdInput!, $input: updateProductInput) {
		updateProduct(productId: $productId, input: $input) {
			underwritingRules
		}
	}
`

export const query = {
	products,
	product,
	benefitGraph,
	pricingLogic,
	underwritingLogic
}

export const mutation = {
	createProduct,
	updateProduct,
	upsertL10n,
	deleteProduct,
	addBenefit,
	updateBenefit,
	removeBenefit,
	createPriceLogic,
	updatePriceLogic,
	updateUnderwritingLogic
}
